module.exports = __webpack_public_path__ + "images/90024cc12985d062c5fc6dbb1c9b866937a827f79baf1c302f6656e9cd1295fa.svg";